import { render, staticRenderFns } from "./SelectMultipleCmsParts.vue?vue&type=template&id=db4e558c&"
import script from "./SelectMultipleCmsParts.vue?vue&type=script&lang=ts&"
export * from "./SelectMultipleCmsParts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports